var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',_vm._l((_vm.videos),function(item,i){return _c('v-col',{key:i,staticClass:"pa-0",attrs:{"cols":"6","sm":"3"}},[_c('CardVideo',{attrs:{"baseTo":'/depoimento/',"item":item}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }